import { render, staticRenderFns } from "./QuejasUsuario.vue?vue&type=template&id=92e8fc5e&"
import script from "./QuejasUsuario.vue?vue&type=script&lang=js&"
export * from "./QuejasUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports